import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { shortNumberFormat } from '../../utils/numbers'
import PanelLayout from './panel_layout'
import UserStat from '../user_stat'
import Dummy from '../dummy'
import ProfileStatsPanelPlaceholder from '../placeholder/profile_stats_panel_placeholder'
import ResponsiveClassesComponent from '../../features/ui/util/responsive_classes_component'

class ProfileStatsPanel extends ImmutablePureComponent {

  render() {
    const { account, noPanel } = this.props

    const Wrapper = noPanel ? Dummy : PanelLayout

    return (
      <Wrapper>
        {
          !account && !noPanel &&
          <ProfileStatsPanelPlaceholder />
        }
        {
          !!account &&
          <ResponsiveClassesComponent
            classNames={[_s.d, _s.flexRow].join(' ')}
            classNamesXS={[_s.d, _s.flexRow, _s.mt15, _s.flexWrap].join(' ')}
          >
            <UserStat
              title='Gabs'
              value={shortNumberFormat(account.get('statuses_count'))}
              numvalue={account.get('statuses_count')}
              to={`/${account.get('acct')}`}
              isInline={noPanel}
            />
            <UserStat
              title='Followers'
              value={shortNumberFormat(account.get('followers_count'))}
              numvalue={account.get('followers_count')}
              to={`/${account.get('acct')}/followers/`}
              isInline={noPanel}
            />
            <UserStat
              isLast
              title='Following'
              value={shortNumberFormat(account.get('following_count'))}
              numvalue={account.get('following_count')}
              to={`/${account.get('acct')}/following`}
              isInline={noPanel}
            />
          </ResponsiveClassesComponent>
        }
      </Wrapper>
    )
  }
}

ProfileStatsPanel.propTypes = {
  account: ImmutablePropTypes.map,
  noPanel: PropTypes.bool,
}

export default ProfileStatsPanel